import type { App } from 'vue'
import {
  Uploader,
  FloatingPanel,
  ActionSheet,
  BackTop,
  Popup,
  Tab,
  Tabs,
  Collapse,
  CollapseItem,
  Overlay,
  PullRefresh,
  List,
  TextEllipsis,
  Swipe,
  SwipeItem
} from 'vant'

export default function useVant(app: App) {
  app
    .use(Uploader)
    .use(FloatingPanel)
    .use(ActionSheet)
    .use(BackTop)
    .use(Popup)
    .use(Tab)
    .use(Tabs)
    .use(Collapse)
    .use(CollapseItem)
    .use(Overlay)
    .use(PullRefresh)
    .use(List)
    .use(TextEllipsis)
    .use(Swipe)
    .use(SwipeItem)
}
